<template>
	<div class="product-category-add">
		<CategorySelector
			class="product-category-add__selector"
			ref="categorySelector"
		/>
		<div class="btn-wrap-main product-category-add__btn-wrap-main">
			<button class="btn-main blue" type="button" @click="register">
				등록
			</button>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash';
	import { mapState } from 'vuex';
	import CategorySelector from '@/components/product/CategorySelector.vue';

	export default {
		name: 'ProductCategoryAdd',
		components: { CategorySelector },
		computed: {
			...mapState('ProductController', ['selectedCategoryList']),
		},
		methods: {
			async register() {
				const categorySelector = this.$refs.categorySelector;
				const category1 = categorySelector.category1;
				const category2 = categorySelector.category2;
				const category3 = categorySelector.category3;
				const nextCategoryDepth = categorySelector.nextCategoryDepth;
				const keywordList = categorySelector.keywordList.map(item => ({
					id: item.id,
					value: item.name,
				}));
				if (
					this.$store.getters['ProductController/hasEmptyCategory'](
						nextCategoryDepth
					) ||
					this.$store.getters['ProductController/hasSameCategory'](
						category1,
						category2,
						category3,
						nextCategoryDepth
					)
				) {
					return;
				}
				this.$store.commit(
					'ProductController/selectedCategoryListAdd',
					{
						category1,
						category2,
						category3,
						keywordList,
						nextCategoryDepth,
					}
				);
				this.$store.commit('modal/toggleModal', false);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.product-category-add {
		font-size: 0;

		.product-category-add__selector {
			margin-top: 18px;
		}

		.product-category-add__btn-wrap-main {
			text-align: right;
			padding-bottom: 0;
		}
	}
</style>
